import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/htrader-logo.png";

const Logout = () => {
  const navigate = useNavigate();
  // console.log("Logout component rendered");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "auto",
        height: "70%",
        marginTop: "20vh",
      }}
    >
      <img src={logo} alt="Logo" style={{ height: 60, marginBottom: 24 }} />
      <p style={{ fontSize: 20 }}>You Have Been Logged Out Successfully</p>
      <button
        style={{
          marginTop: 32,
          padding: "10px 24px",
          fontSize: 16,
          borderRadius: 6,
          border: "none",
          background: "#1976d2",
          color: "#fff",
          cursor: "pointer",
        }}
        onClick={() => navigate("/auth")}
      >
        Sign In Again
      </button>
    </div>
  );
};

export default Logout;
